module.exports = __webpack_public_path__ + "static/media/iframe-simple-flow_ro.13766a3c.gif";